import {
    getProduct,
    listProducts
} from './queries';
import {
    createProduct,
    deleteProduct,
    updateProduct,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {Product} from "../types.ts";
import {generateClient} from "aws-amplify/api";


export type ListProducts = {
    listProducts: { items: Product[], nextToken?: string }
}

export type GetProduct = {
    getProduct: Product
}

export type CreateProduct = {
    createProduct: Product
}

export type UpdateProduct = {
    updateProduct: Product
}

export type DeleteProduct = {
    deleteProduct: string
}

const client = generateClient();

export const fetchRecords = async (filter: object, limit?: number, nextToken?: string) => {
    const response = await client.graphql<GraphQLQuery<ListProducts>>({
                                                                          query: listProducts,
                                                                          variables: {filter: filter, limit, nextToken},
                                                                      });
    return response.data?.listProducts;
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetProduct>>({
                                                                        query: getProduct,
                                                                        variables: {id: id},
                                                                    });
    return response.data?.getProduct;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateProduct>>({
                                                                           query: createProduct,
                                                                           variables: {input: payload},
                                                                       });
    return response.data?.createProduct;
};

// FNP-918 (§6): this function used to do `delete record.created` on the CALLER'S
// object — not a copy. That is the FNP-996 defect verbatim: it strips fields off
// the live Formik / React Query record, so the form the operator is looking at
// silently loses data the moment they hit save, and the cached row loses it too.
//
// The payload now arrives already WHITELISTED by `toProductInput` in
// hooks/useProduct.ts, which is the single place that decision belongs.
export const update = async (_id: string, record: Product) => {
    const response = await client.graphql<GraphQLQuery<UpdateProduct>>({
                                                                           query: (updateProduct),
                                                                           variables: {input: record},
                                                                       });
    return response.data?.updateProduct;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteProduct>>({
                                                                           query: (deleteProduct),
                                                                           variables: {input: {id: id}},
                                                                       });
    return response.data?.deleteProduct;
};
